import React from 'react'
import Typewriter from 'typewriter-effect';

const TypewriterEffect = () => {
  
  return (
    <Typewriter
        onInit={(typewriter) => {
            typewriter.typeString('Rafael Gutiérrez J.')
            .start();
        }}
        options= {{
          cursor:''
        }}
    />
  )
}


export default TypewriterEffect

